import styled from '@emotion/styled';
import React, { ReactElement } from 'react';
import { Button } from '../../Marketing/Button';
import { OL_COLOUR_NAVY_BABY } from '../../Style/colours';
import { ExceededUsageLimitType } from './types';

const Container = styled.div({
  padding: 16,
  backgroundColor: OL_COLOUR_NAVY_BABY,
  color: 'white',
  fontSize: 16,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

const Message = styled.div({
  marginRight: 8,
});

export const LearnerUsageExceededBanner = ({
  isOwner,
  limitType,
  onClick,
}: {
  isOwner: boolean;
  limitType: ExceededUsageLimitType;
  onClick?: () => void;
}): ReactElement => (
  <Container>
    <Message>
      {isOwner ? (
        <div>
          You have{' '}
          <strong>
            reached the{' '}
            {limitType === 'educator' ? 'educator count' : 'learner usage'}{' '}
            limit
          </strong>{' '}
          on your subscription plan.
        </div>
      ) : (
        <div>
          {limitType === 'educator' ? 'Educator count ' : 'Learner usage '}
          limit has been reached on your subscription plan, please contact your
          subscription owner to upgrade.
        </div>
      )}
    </Message>
    {isOwner && onClick && (
      <Button
        variant="legacy-cta-pink"
        action={{
          kind: 'on_click',
          value: onClick,
        }}
      >
        Upgrade plan
      </Button>
    )}
  </Container>
);
